module.exports = __webpack_public_path__ + "media/promo/promo/images/soc-2-652a45e5600bece8e21e96bd6abcf4eb.svg";